import { getMaster } from "utils/api";
import moment from "moment";

export const getAbnormalReport = async (params) => {
  if (params.startTime) {
    params.startTime = moment(params.startTime).toISOString(true);
  }

  if (params.endTime) {
    params.endTime = moment(params.endTime).toISOString(true);
  }

  return await getMaster("/reports", {
    ...params,
  });
};
